import type { FeatureModule } from '../types';
import riyaFeature from './riya';
import controllerFeature from './controller';
import sortingHatDebugFeature from './debug';

export const riyaFeatures: FeatureModule[] = [
  riyaFeature,
  controllerFeature,
  sortingHatDebugFeature
];
